const $ = require('jquery')

// Bootstrap のスクロールスパイのような実装
//
// * アンカーリンクに .js-scroll-spy-link クラスをつける
// * アンカーリンクの href に書いたセレクター（正しくは URL Hash）が指し示す要素をセクションとして認識
// * スクロール位置がアンカーリンクのところまで来たら、アンカーリンクに active クラスを付与する
$(function () {
  const spyLinks = $('.js-scroll-spy-link').toArray()

  // リンククリックで指定の位置にスクロールしたときに、スクロール位置よりもセクションの位置が下にあることがある。
  // この場合、リンクをクリックしても、クリックしたリンクが active 状態にならないので、数十ピクセル分、セクションを先読みする。
  // この const は、そのための先読み高さ。
  const lookaheadHeight = 45

  const calculateSectionPositions = () => {
    return spyLinks.map((link) => {
      const hash = link.hash
      const section = $(hash)
      const offsetTop = section.offset().top

      return {
        hash,
        link,
        offsetTop
      }
    }).sort((a, b) => a.offsetTop - b.offsetTop).reverse()
  }

  $(window).on('scroll', () => {
    const sectionPositions = calculateSectionPositions()

    const scrollTop = window.scrollY
    const current = sectionPositions.find((sectionPosition) => scrollTop + lookaheadHeight > sectionPosition.offsetTop)
    const otherSectionPositions = sectionPositions.filter((sectionPosition) => sectionPosition != current)

    if (current) $(current.link).addClass('active')
    otherSectionPositions.forEach((sectionPosition) => $(sectionPosition.link).removeClass('active'))
  })
})
